import { Injectable } from '@angular/core';
import { Overlay, OverlayRef, ConnectedPosition, FlexibleConnectedPositionStrategy } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OverlayService {
  private overlayRef: OverlayRef | null = null;
  private positionStrategy!: FlexibleConnectedPositionStrategy;
  isOpen$ = new BehaviorSubject<boolean>(false);

  constructor(private overlay: Overlay) {}

  init(origin: HTMLElement, positions: ConnectedPosition[]) {
    if (!this.overlayRef) {
      this.positionStrategy = this.overlay.position()
        .flexibleConnectedTo(origin)
        .withPositions(positions)
        .withFlexibleDimensions(true);

      this.overlayRef = this.overlay.create({
        positionStrategy: this.positionStrategy,
        scrollStrategy: this.overlay.scrollStrategies.reposition(),
      });
      this.overlayRef.backdropClick().subscribe(() => this.close());
    } else {
      this.positionStrategy.setOrigin(origin);
    }
  }

  open(template: TemplatePortal<any>) {
    if (!this.overlayRef) { return; }
    this.overlayRef.attach(template);
    this.isOpen$.next(true);
  }

  close() {
    if (!this.overlayRef) { return; }
    this.overlayRef.detach();
    this.isOpen$.next(false);
  }
}
